"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AperturaSoporte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="soporte-apertura" id="apertura-soporte" className="bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="font-mono text-xs tracking-widest text-primary uppercase mb-6">
            03 · Operación estable
          </div>

          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-normal text-foreground leading-[1.05] mb-8">
            Fulcro Soporte
          </h1>

          <p className="font-serif italic text-2xl md:text-3xl text-foreground/90 leading-snug mb-10 max-w-3xl">
            Mantenimiento profesional cuando lo grande ya se construyó.
          </p>

          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            Iguala mensual. Para infraestructura en operación estable.
          </p>
        </div>
      </div>
    </section>;
}